export const enum EqfStatus {
  full = "full",
  partial = "partial",
  none = "none",
}
